"use strict"; // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var PlatformEvent_1 = require("./PlatformEvent");

var AudioSourceEvent =
/** @class */
function (_super) {
  __extends(AudioSourceEvent, _super);

  function AudioSourceEvent(eventName, audioSourceId, eventType) {
    if (eventType === void 0) {
      eventType = PlatformEvent_1.EventType.Info;
    }

    var _this = _super.call(this, eventName, eventType) || this;

    _this.privAudioSourceId = audioSourceId;
    return _this;
  }

  Object.defineProperty(AudioSourceEvent.prototype, "audioSourceId", {
    get: function get() {
      return this.privAudioSourceId;
    },
    enumerable: true,
    configurable: true
  });
  return AudioSourceEvent;
}(PlatformEvent_1.PlatformEvent);

exports.AudioSourceEvent = AudioSourceEvent; // tslint:disable-next-line:max-classes-per-file

var AudioSourceInitializingEvent =
/** @class */
function (_super) {
  __extends(AudioSourceInitializingEvent, _super);

  function AudioSourceInitializingEvent(audioSourceId) {
    return _super.call(this, "AudioSourceInitializingEvent", audioSourceId) || this;
  }

  return AudioSourceInitializingEvent;
}(AudioSourceEvent);

exports.AudioSourceInitializingEvent = AudioSourceInitializingEvent; // tslint:disable-next-line:max-classes-per-file

var AudioSourceReadyEvent =
/** @class */
function (_super) {
  __extends(AudioSourceReadyEvent, _super);

  function AudioSourceReadyEvent(audioSourceId) {
    return _super.call(this, "AudioSourceReadyEvent", audioSourceId) || this;
  }

  return AudioSourceReadyEvent;
}(AudioSourceEvent);

exports.AudioSourceReadyEvent = AudioSourceReadyEvent; // tslint:disable-next-line:max-classes-per-file

var AudioSourceOffEvent =
/** @class */
function (_super) {
  __extends(AudioSourceOffEvent, _super);

  function AudioSourceOffEvent(audioSourceId) {
    return _super.call(this, "AudioSourceOffEvent", audioSourceId) || this;
  }

  return AudioSourceOffEvent;
}(AudioSourceEvent);

exports.AudioSourceOffEvent = AudioSourceOffEvent; // tslint:disable-next-line:max-classes-per-file

var AudioSourceErrorEvent =
/** @class */
function (_super) {
  __extends(AudioSourceErrorEvent, _super);

  function AudioSourceErrorEvent(audioSourceId, error) {
    var _this = _super.call(this, "AudioSourceErrorEvent", audioSourceId, PlatformEvent_1.EventType.Error) || this;

    _this.privError = error;
    return _this;
  }

  Object.defineProperty(AudioSourceErrorEvent.prototype, "error", {
    get: function get() {
      return this.privError;
    },
    enumerable: true,
    configurable: true
  });
  return AudioSourceErrorEvent;
}(AudioSourceEvent);

exports.AudioSourceErrorEvent = AudioSourceErrorEvent; // tslint:disable-next-line:max-classes-per-file

var AudioStreamNodeEvent =
/** @class */
function (_super) {
  __extends(AudioStreamNodeEvent, _super);

  function AudioStreamNodeEvent(eventName, audioSourceId, audioNodeId) {
    var _this = _super.call(this, eventName, audioSourceId) || this;

    _this.privAudioNodeId = audioNodeId;
    return _this;
  }

  Object.defineProperty(AudioStreamNodeEvent.prototype, "audioNodeId", {
    get: function get() {
      return this.privAudioNodeId;
    },
    enumerable: true,
    configurable: true
  });
  return AudioStreamNodeEvent;
}(AudioSourceEvent);

exports.AudioStreamNodeEvent = AudioStreamNodeEvent; // tslint:disable-next-line:max-classes-per-file

var AudioStreamNodeAttachingEvent =
/** @class */
function (_super) {
  __extends(AudioStreamNodeAttachingEvent, _super);

  function AudioStreamNodeAttachingEvent(audioSourceId, audioNodeId) {
    return _super.call(this, "AudioStreamNodeAttachingEvent", audioSourceId, audioNodeId) || this;
  }

  return AudioStreamNodeAttachingEvent;
}(AudioStreamNodeEvent);

exports.AudioStreamNodeAttachingEvent = AudioStreamNodeAttachingEvent; // tslint:disable-next-line:max-classes-per-file

var AudioStreamNodeAttachedEvent =
/** @class */
function (_super) {
  __extends(AudioStreamNodeAttachedEvent, _super);

  function AudioStreamNodeAttachedEvent(audioSourceId, audioNodeId) {
    return _super.call(this, "AudioStreamNodeAttachedEvent", audioSourceId, audioNodeId) || this;
  }

  return AudioStreamNodeAttachedEvent;
}(AudioStreamNodeEvent);

exports.AudioStreamNodeAttachedEvent = AudioStreamNodeAttachedEvent; // tslint:disable-next-line:max-classes-per-file

var AudioStreamNodeDetachedEvent =
/** @class */
function (_super) {
  __extends(AudioStreamNodeDetachedEvent, _super);

  function AudioStreamNodeDetachedEvent(audioSourceId, audioNodeId) {
    return _super.call(this, "AudioStreamNodeDetachedEvent", audioSourceId, audioNodeId) || this;
  }

  return AudioStreamNodeDetachedEvent;
}(AudioStreamNodeEvent);

exports.AudioStreamNodeDetachedEvent = AudioStreamNodeDetachedEvent; // tslint:disable-next-line:max-classes-per-file

var AudioStreamNodeErrorEvent =
/** @class */
function (_super) {
  __extends(AudioStreamNodeErrorEvent, _super);

  function AudioStreamNodeErrorEvent(audioSourceId, audioNodeId, error) {
    var _this = _super.call(this, "AudioStreamNodeErrorEvent", audioSourceId, audioNodeId) || this;

    _this.privError = error;
    return _this;
  }

  Object.defineProperty(AudioStreamNodeErrorEvent.prototype, "error", {
    get: function get() {
      return this.privError;
    },
    enumerable: true,
    configurable: true
  });
  return AudioStreamNodeErrorEvent;
}(AudioStreamNodeEvent);

exports.AudioStreamNodeErrorEvent = AudioStreamNodeErrorEvent;